export default "__VITE_ASSET__4c621b3c__"